import { render } from "./PopupCard.vue?vue&type=template&id=50c582d5"
import script from "./PopupCard.vue?vue&type=script&lang=js"
export * from "./PopupCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__